export default {
  // investment
  SET_INDIVIDUAL_INVESTMENT (state, investment) {
    state.individualInvestment = investment
    if (!state.individualInvestment.becomeClientData) {
      state.individualInvestment.becomeClientData = []
    }
  },
  UPDATE_INDIVIDUAL_INVESTMENT (state, investment) {
    state.individualInvestment = investment
  },
  // photo
  LOAD_INVESTMENT_PHOTO ({individualInvestment}, {photo}) {
    if (individualInvestment) {
      individualInvestment.photo = photo
    }
  },
  LOAD_INVESTMENT_ABOUT_PREVIEW ({individualInvestment}, {photo}) {
    if (individualInvestment) {
      individualInvestment.aboutPreview = photo
    }
  },
  LOAD_INVESTMENT_PATH_PREVIEW ({individualInvestment}, {photo}) {
    if (individualInvestment) {
      individualInvestment.pathPreview = photo
    }
  },
  // advantage
  ADD_INVESTMENT_ADVANTAGE ({individualInvestment}, advantage) {
    individualInvestment.advantages.push(advantage)
  },
  DELETE_INVESTMENT_ADVANTAGE ({individualInvestment}, id) {
    individualInvestment.advantages = individualInvestment.advantages.filter(a => a.id !== id)
  },
  UPDATE_INVESTMENT_ADVANTAGE ({individualInvestment}, {id, title, description, learnMoreButton, order}) {
    const advantage = individualInvestment.advantages.find(a => a.id === id)
    Object.assign(advantage, {title, description, learnMoreButton, order})
  },
  // path
  DELETE_INVESTMENT_PATH ({individualInvestment}, id) {
    individualInvestment.pathes = individualInvestment.pathes.filter(p => p.id !== id)
  },
  ADD_INVESTMENT_PATH ({individualInvestment}, path) {
    if (!individualInvestment.pathes) {
      individualInvestment.pathes = [path]
    } else {
      individualInvestment.pathes.push(path)
    }
  },
  UPDATE_INVESTMENT_PATH ({ individualInvestment }, { id, title, description, link, button_title, button_link, order }) {
    const path = individualInvestment.pathes.find(p => p.id === id)
    Object.assign(path, {title, description, link, button_title, button_link, order})
  },
  // rate
  ADD_INVESTMENT_RATE ({individualInvestment}, rate) {
    individualInvestment.rates.push(rate)
  },
  UPDATE_INVESTMENT_RATES ({individualInvestment}, rates) {
    individualInvestment.rates = rates
  },
  UPDATE_INVESTMENT_RATE ({individualInvestment}, {id, title, description, text, order}) {
    const rate = individualInvestment.rates.find(r => r.id === id)
    Object.assign(rate, {title, description, text, order})
  },
  DELETE_INVESTMENT_RATE ({individualInvestment}, id) {
    individualInvestment.rates = individualInvestment.rates.filter(r => r.id !== id)
  },
  // review photo
  CHANGE_INVESTMENT_REVIEW_PHOTO ({individualInvestment}, {id, photo}) {
    if (individualInvestment) {
      const review = individualInvestment.reviews.find(s => s.id === id)
      review.photo = photo
    }
  },
  // rates file
  CHANGE_INVESTMENT_RATES_FILE ({individualInvestment}, file) {
    individualInvestment.ratesComparisonFile = file
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/individualInvestment.js